import axios from 'axios'

export const getProfile = profile =>
   axios.get(`profile/${profile}`)

export const toggleFollow = (id, option) =>
   axios.post(`user/${option}`, {id})

export const getInfo = () =>
   axios.get(`user/info`)

export const getFinance = () =>
   axios.get(`finance/info`)

export const saveBasic = form =>
   axios.post(`user/save`, form)


export const saveFinance = form =>
   axios.post(`finance/save`, form)

export const follow = (username, type = 'following', start = 0, limit = 30) =>
   axios.post(`user/${username}/${type}`, { start, limit })

export const events = (identification, start, limit) =>
   axios.post(`${window.URL_API_EVENT}event/findbyuser/${identification}`, {
      start,
      limit,
      orderBy: 'startDate',
      order: 'desc'
   })

export const eventsFuture = (identification, start, limit) =>
   axios.post(`${window.URL_API_EVENT}event/findbyuser/${identification}`, {
      start,
      limit,
      orderBy: 'startDate',
      order: 'asc',
      timePeriod: 'future'
   })

export const getExperience = (username, start, limit) =>
   axios.post(`${window.URL_API_EXPERIENCE}experience/findbyuser/${username}`, {
      start,
      limit
   })

export const eventsPast = (identification, start, limit) =>
   axios.post(`${window.URL_API_EVENT}event/findbyuser/${identification}`, {
      start,
      limit,
      orderBy: 'startDate',
      order: 'desc',
      timePeriod: 'past'
   })

export const inscriptions = (identification, start, limit) =>
   axios.post(`subscription/list/`, {
      start,
      limit,
      userChargedId: identification
   })

export const subscriptionExperiences = (start, limit) =>
   axios.get(`subscription/experiences/${start}/${limit}`)

export const getNotifications = (start, end) =>
   axios.post(`${window.URL_API}notification/list_all/all/${start}/${end}`)


export const uploadAvatar = (file, progress) => {
   var form = new FormData()
   form.append('image', file)
   return axios.post(`avatar/upload`, form, {
      onUploadProgress: progressEvent => {
         let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
         progress(percentCompleted)
      }
   })
}

export const uploadCover = (file, progress) => {
    var form = new FormData()
    form.append('image', file)
    return axios.post(`cover/upload`, form, {
        onUploadProgress: progressEvent => {
            let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            progress(percentCompleted)
        }
    })
}

export const appsMine = () => 
   axios.get(`${window.URL_API}apps/mine`)

export const authorizeStrava = (code) =>
   axios.post(`${window.URL_API}apps/authorize/strava`, { code })

export const unauthorizeStrava = () =>
   axios.post(`${window.URL_API}apps/unauthorize/strava`)



const URL_API_AFFILIATE = 'https://api.sprinta.com.br/affiliate/'

export const affiliateMe = username =>
   axios.get(URL_API_AFFILIATE + 'me/' + username)

export const affiliateRequest = username =>
   axios.post(URL_API_AFFILIATE + 'request/' + username, {})

export const affiliateStats = username =>
   axios.get(URL_API_AFFILIATE + 'stats/' + username)

export const affiliateEvents = username =>
   axios.get(URL_API_AFFILIATE + 'events/' + username)

export const affiliateMaterials = eventId =>
   axios.get(URL_API_AFFILIATE + 'materials/' + eventId)


// WEBPACK FOOTER //
// ./src/App/utils/user.js